shadow$provide[482] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Layout:{enumerable:true, get:function() {
  return Layout;
}}});
var require$_DOT__SLASH_snippet = require("./snippet");
var require$_DOT__SLASH_link = require("./link");
const debug = false;
class Layout {
  constructor(language, graph) {
    this.language = language;
    this.graph = graph;
    this.links = [];
    this.includes = [];
    this.modules = {};
    this.visits = {};
  }
  callback(node, module, priority, name, external) {
    return this.links.push({node, module, priority, name, external});
  }
  include(node, module, priority) {
    let m;
    if ((m = this.modules[module.namespace]) != null) {
      return m.priority = Math.max(priority, m.priority);
    } else {
      this.modules[module.namespace] = true;
      return this.includes.push({node, module, priority});
    }
  }
  visit(namespace) {
    debug && console.log("Visit", namespace, !this.visits[namespace]);
    if (this.visits[namespace]) {
      return false;
    }
    return this.visits[namespace] = true;
  }
  link(module) {
    const data = (0,require$_DOT__SLASH_link.link)(this.language, this.links, this.includes, module);
    const snippet = new require$_DOT__SLASH_snippet.Snippet();
    for (const key in data) {
      snippet[key] = data[key];
    }
    snippet.graph = this.graph;
    return snippet;
  }
}

};